"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function Projects() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const topics = [{
    title: "Gülüş Tasarımı (Hollywood Smile) Nedir?",
    content: "Hollywood Smile; estetik diş hekimliğinin en kapsamlı uygulamalarından biridir. Kayseri’de gülüş tasarımı yaptırmak isteyen hastalarımız için porselen lamina, zirkonyum kaplama ve diş eti estetiği gibi işlemlerle kusursuz bir görünüm oluşturulur.",
    image: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/20210425114714_6085d552f3ca3.png?v=cqfd9hwcjon"
  }, {
    title: "Kayseri’de Gülüş Tasarımı Nasıl Yapılır?",
    content: "Kliniğimizde süreç dijital gülüş analizi ile başlar. Mock-up (ön tasarım) aşamasında tedavi sonucu size önceden gösterilir. Kayseri’de modern ekipman ve güncel tekniklerle hızlı ve güvenilir sonuçlar sunuyoruz.",
    image: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/gulus-tasarimi-ic.jpg?v=mkngjk05sr"
  }, {
    title: "Tasarımın Estetik Avantajları",
    content: "Yüz hatlarıyla uyumlu, doğal ve özgüvenli bir gülüş sağlar. Hollywood Smile sayesinde sadece dişleriniz değil, genel yüz ifadeniz de gençleşir. Uzun ömürlü ve dayanıklı materyallerle estetik bütünlük elde edilir.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/hollywood_smile_benefits.png"
  }, {
    title: "Kayseri Gülüş Tasarımı Randevusu",
    content: "Siz de Kayseri’de Hollywood Smile yaptırmak ve estetik bir gülüşe sahip olmak istiyorsanız, hemen bizimle iletişime geçin. Diş Hekimi Ayşegül İnneci Uzun kliniğinde size özel çözümler sunulmaktadır.",
    image: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_2418.JPG-1-scaled-e1775730535235.jpeg?v=kf0ngvvppif"
  }, {
    title: "Gülüş Tasarımı Fiyatları",
    content: "Kayseri’de Hollywood Smile fiyatları; uygulanacak işlemlere ve kullanılacak materyallere göre değişiklik göstermektedir. Net bilgi almak için kliniğimize başvurarak ön muayene yaptırabilirsiniz.",
    image: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/yeni-proje-2024-04-16t100443-120_1713251100.webp?v=os8oq0znzyi"
  }, {
    title: "Neden Kliniğimizi Seçmelisiniz?",
    content: "Modern klinik ortamı, dijital tasarım teknolojisi ve hasta memnuniyeti odaklı yaklaşımımızla hizmet veriyoruz. Diş Hekimi Ayşegül İnneci Uzun olarak hayalinizdeki gülüşe ulaşmanız için yanınızdayız.",
    image: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_2371.JPG-1-scaled-e1775730482219.jpeg?v=me2q2uiye69"
  }];
  return <section data-section-id="184775" id="hollywood-smile-tasarimi" className="relative bg-linear-to-b from-background to-secondary/20 py-32 md:py-48 lg:py-56 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        
        <div ref={headerRef} className={`flex flex-col items-center text-center max-w-4xl mx-auto mb-20 md:mb-32 transition-all duration-1000 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="font-sans text-xs md:text-sm font-semibold tracking-widest uppercase text-primary mb-6">
            Öne Çıkan Tedavilerimiz
          </span>
          <h2 className="font-serif text-5xl md:text-6xl lg:text-8xl text-foreground leading-tight tracking-tight">
            Kayseri Gülüş Tasarımı <br />(Hollywood Smile)
          </h2>
          <Separator className="w-24 bg-primary/40 mt-10" />
        </div>

        <div className={`transition-all duration-1000 delay-300 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="max-w-4xl mx-auto text-center space-y-6 mb-16 md:mb-24">
            <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed">
              Kayseri’de Hollywood Smile (gülüş tasarımı) uygulamalarıyla, yüzünüze en uygun estetik ve doğal gülüşe kavuşabilirsiniz. Diş Hekimi Ayşegül İnneci Uzun Kliniği olarak; dijital planlama, ileri teknoloji ve kişiye özel estetik yaklaşım ile gülüşünüzü baştan tasarlıyoruz.
            </p>
            <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed">
              Gülüş tasarımı; dişlerin rengi, formu, dizilimi ve diş eti uyumunun birlikte değerlendirilerek yüz hatlarınıza en uygun hale getirilmesidir. Kayseri’de profesyonel gülüş tasarımı hizmetimiz sayesinde daha beyaz, simetrik ve sağlıklı bir gülüş elde edebilirsiniz.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
            {topics.map((topic, i) => <Card key={i} data-index={i} className="group bg-card/50 backdrop-blur-sm border-none shadow-sm hover:shadow-xl hover:bg-secondary/30 transition-all duration-500 overflow-hidden">
                <div className="aspect-video overflow-hidden">
                  <img src={topic.image} alt={topic.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <CardHeader className="pb-4 pt-6">
                  <CardTitle className="font-serif text-xl md:text-2xl text-foreground group-hover:text-primary transition-colors duration-300">
                    {topic.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pb-8">
                  <p className="font-sans text-sm md:text-base text-muted-foreground leading-relaxed">
                    {topic.content}
                  </p>
                </CardContent>
              </Card>)}
          </div>

          <div className="mt-16 md:mt-24 text-center">
            <Link to="https://wa.me/905535523234?text=Merhaba%20randevu%20almak%20istiyorum" className="inline-flex items-center justify-center px-10 py-4 bg-primary text-primary-foreground font-sans font-medium tracking-widest uppercase text-sm hover:bg-primary/90 transition-all duration-300 shadow-sm hover:shadow-md">Ön MUAYENE İçin Randevu Alın</Link>
          </div>
        </div>

      </div>
    </section>;
}